/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'machao-1': {
    sides: [
      { f: 'han', n: '鍾繇', l: '鍾繇；馬超、龐德（馬騰派來助戰）', w: 1 },
      { f: 'ys', n: '袁尚', l: '郭援、高幹' },
    ],
    before: '匈奴單于在平陽作亂，司隸校尉鍾繇率軍圍城。袁尚任命的河東太守郭援帶大軍趕來，諸將想撤，鍾繇不肯。張既說動馬騰出兵，馬騰派兒子馬超領兵會擊郭援。',
    after: '郭援輕率渡汾水，渡到一半被擊潰，龐德親手斬下郭援的首級，單于投降。據《典略》，馬超在這一戰中箭，用布囊裹腳繼續作戰，戰後拜徐州刺史，後來又拜諫議大夫。',
    src: '《三國志·蜀書·馬超傳》；〈鍾繇傳〉；裴注引《典略》',
  },
  'machao-2a': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、許褚、徐晃、朱靈', w: 1 },
      { f: 'xl', n: '關西聯軍', l: '馬超、韓遂、梁興' },
    ],
    before: '馬騰入朝當衛尉，馬超接管父親的部眾。建安十六年，馬超和韓遂、楊秋、李堪、成宜等關西十部一起起兵，屯據潼關。曹操親自西征，暗中派徐晃、朱靈從蒲阪津夜渡黃河，在河西立營。據《山陽公載記》，馬超勸韓遂在渭北阻擋，韓遂沒有聽。',
    after: '梁興夜襲徐晃，被徐晃擊退。曹操從潼關北渡時，馬超趕到碼頭急攻，許褚舉馬鞍替曹操擋箭；校尉丁斐放出牛馬引誘關西兵去搶，曹操才渡過河。',
    src: '《三國志·魏書·武帝紀》；〈徐晃傳〉〈許褚傳〉；〈馬超傳〉裴注引《山陽公載記》',
  },
  'machao-3a': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹操、許褚（賈詡出計）', w: 1 },
      { f: 'xl', n: '關西聯軍', l: '馬超、韓遂等十部' },
    ],
    before: '曹操渡過渭水，在渭南立營。聯軍幾次挑戰不利，請求割地講和。曹操答應和韓遂、馬超單馬會語。',
    after: '馬超本想趁機捉住曹操，被許褚瞪住不敢動。曹操和韓遂只談京都舊事，又寄給韓遂一封塗改過的信，照賈詡「離之而已」的計策離間，馬超等人越來越懷疑韓遂。',
    src: '《三國志·蜀書·馬超傳》；《武帝紀》〈許褚傳〉〈賈詡傳〉',
  },
  'machao-4': {
    sides: [
      { f: 'wei', n: '曹操', l: '曹仁、夏侯淵、張郃、徐晃、許褚', w: 1 },
      { f: 'xl', n: '關西聯軍', l: '馬超、韓遂、成宜、李堪、楊秋' },
    ],
    before: '關西聯軍互相猜疑，曹操約定日期決戰。他先派輕兵挑戰，打了很久，再放出虎騎從兩側夾擊。',
    after: '關西軍大敗，成宜、李堪被斬。馬超、韓遂逃往涼州，楊秋逃到安定，關中平定。龐德隨馬超逃入漢陽。',
    src: '《三國志·魏書·武帝紀》；〈曹仁傳〉〈夏侯淵傳〉〈張郃傳〉〈龐德傳〉',
  },
  'machao-5a': {
    sides: [
      { f: 'xl', n: '馬超', l: '馬超、龐德（張魯派楊昂助戰）' },
      { f: 'han', n: '涼州州郡', l: '韋康；楊阜、姜敘、趙衢、梁寬', w: 1 },
    ],
    before: '建安十七年五月，留在朝中的馬騰被誅，夷滅三族（《後漢書》）。馬超率羌、氐諸部攻打隴上郡縣，隴上郡縣都響應，只有冀城固守。楊阜從正月守到八月，援兵始終沒來，刺史韋康開城投降，馬超派楊昂殺了刺史、太守。',
    after: '同年九月，楊阜、姜敘在鹵城起兵，馬超出城攻打，攻不下來；趙衢、梁寬在背後關上冀城城門，殺了馬超的妻兒。楊阜和馬超交戰，身受五處傷。馬超進退無路，南奔漢中投靠張魯。',
    src: '《三國志·蜀書·馬超傳》；〈楊阜傳〉〈夏侯淵傳〉《武帝紀》；《後漢書·獻帝紀》',
  },
  'machao-6': {
    sides: [
      { f: 'shu', n: '劉備', l: '劉備、馬超', w: 1 },
      { f: 'lz', n: '劉璋', l: '劉璋' },
    ],
    before: '馬超在張魯那裡不得志。他聽說劉備正在成都圍攻劉璋，就寫密信請降，從武都逃進氐人地區，轉往蜀地。據《典略》，劉備聽說馬超來了，高興地說「我得益州矣」，暗中撥兵給他。',
    after: '馬超帶兵直到成都城下，城中震恐，劉璋隨即投降。劉備任命馬超為平西將軍，後來升到驃騎將軍、涼州牧。馬超四十七歲去世，臨終上疏說宗族二百多口幾乎被曹操殺盡，只剩堂弟馬岱；馬岱後來官至平北將軍，封陳倉侯。',
    src: '《三國志·蜀書·馬超傳》；裴注引《典略》',
  },
};
